// extracted by mini-css-extract-plugin
module.exports = {"Container":"FatalError_Container__1P65k","Header":"FatalError_Header__Xi-0m","Message":"FatalError_Message__3WkhL","Help":"FatalError_Help__39_rY"};